<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：フォルダ・ファイルの複写・移動画面(STFM02C21CopyMoveModal)                                          _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <!-- ポップアップ：アクセス権限の複写 -->
  <div
    class="overlay" 
    :class="[isCopyMoveShow ? showClass : hideClass]"
    id="popup-copymove"
    :ref="copymovecontent">
    <div class="popup" style="width: 920px">
      <div class="popup-head" v-if="moveFlg">{{actionMove}}</div>
      <div class="popup-head" v-else>{{actionCopy}}</div>
      
      <div class="popup-body blue">
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <error-message :errors="errors"></error-message>
        </p> 
        <div class="mt-10px">
          <p v-if="moveFlg">{{actionMove}}先を選択してください。</p>
          <p v-else>{{actionCopy}}先を選択してください。</p>
        </div>
        <div class="frm-row">
          <span class="frm-label w-70px">フォルダ名</span>
          <input type="text" class="frm-text frm-size-full" 
          v-model="destFolderInfo.destPath" readonly="readonly" 
          tabindex="2">
          <button class="frm-btn-control frm-text frm-btn-text frm-size-ss plr-0"
           id="select-destpath-btn"
           @click="selectBtnClicked()" 
           tabindex="1"
           ref="selectdestbtn">選択</button>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button class="frm-btn strong large" @click="execBtnClicked()" tabindex="3">確定</button>
              <button class="frm-btn large" 
              @click="canselBtnClicked()" 
              tabindex="4" 
              @blur="onblur">キャンセル</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<STFMF02C22 v-if="isFolderListShow" 
  :is-folder-list-show="isFolderListShow"
  :current-folder="currentFolder" 
  @close-stfmf02c22="closeSTFMF02C22" ></STFMF02C22>

</template>
  <!-- ポップアップ：アクセス権限の複写 // -->
<script>
    import Common from "@/util/common.js";
    import STFMF02C22 from './STFMFM02C22FolderListModal.vue';
    import ErrorMessage from '@/components/ErrorMessage.vue'
    import {API_STFMFM02C21} from '@/api/Modules/FM02/STFMFM02C21.js';
    import { mapGetters, mapMutations } from "vuex";
    
    export default {
      name: 'STFMF02C21',
      components:{
        STFMF02C22,  // フォルダ一覧画面
        ErrorMessage,
      },
      watch:{
        isCopyMoveShow:{
          //immediate: true,
          handler(newVal){
            if(newVal == true){
              this.initialize();
            }
            this.handleBodyScrollOnModalStateChange(newVal)
          }
        }
      },
      data() {
        return {
          showClass: "show",
          hideClass: "hide",
          actionCopy: "複写", // 複写or移動
          actionMove: "移動",
          destFolderInfo: {   // 移動・複写先
            name:"", 
            destPath: "",   // パス
            destfolderkey:"",
          },
          currentFolder:{   // 選択中のフォルダ情報
            name:"",
            folderPath:"",
          },
          errors:[],  
          isFolderListShow: false,
          fileListpageIdChild:"",
          srcFileKeyList:[],
          srcFolderKeyList:[],
        };
      },
      props:{
        isCopyMoveShow:{
          type:Boolean,
          required:true,
        },
        moveFlg:{         // 移動操作フラグ
          type: Boolean,
          //default: true,
        },
        srcFileList:{ // 複写・移動対象ファイルリスト
          type: Object,
        },
        srcFolderList:{ // 複写・移動対象フォルダリスト
          type: Object,
        },
        // ログインユーザ種別 true:達人ユーザ、false:事業者
        isTzuser: {
          type: Boolean,
          required: true,
        },
        // ログインユーザの機能利用権限[フォルダ・ファイルの操作【作成/編集/削除/移動/複写】  true:権限有、false:権限無
        fmFolderOperation: {
          type: Boolean,
          required: true,
        },
        // ログインユーザの機能利用権限[ファイルの操作【登録/編集/削除/移動/複写】  true:権限有、false:権限無
        fmFileOperation: {
          type: Boolean,
          required: true,
        },
      },
      methods:{
        ...mapMutations("businessModule",["processDialogue","handleBodyScrollOnModalStateChange"]),
        // **********************************************
        // * 初期処理
        // **********************************************
        initialize(){
          // ファイル情報->ファイルキー情報
          this.convertFileInfoToFileKey();
          // フォルダ情報->フォルダキー情報
          this.convertFolderInfoToFolderKey();
          this.$nextTick(function () {
            return this.initfocus();

          });
        },
        // **********************************************
        // * 選択ボタンをクリック
        // **********************************************
        selectBtnClicked(){
          this.fileListpageIdChild = this.fileListpageId
          this.currentFolder.name = this.destFolderInfo.name;
          this.currentFolder.folderPath = this.destFolderInfo.destPath;
          this.clearError();
          this.isFolderListShow = true;
        },
        // **********************************************
        // * 確定ボタンをクリック
        // **********************************************
        execBtnClicked(){
          this.clearError();
          // フォルダ名空白チェック
          if(this.destFolderInfo.destPath === ""){
            // フォルダ未選択エラー          
            this.errors.push(
              Common.createError("MTCL1034",Common.getMessage("MTCL1034",["フォルダ"]))
            );
            return;
          }
          else{
            this.processDialogue(true);
            let param = {
              MoveFlg: this.moveFlg,
              SrcFileInfoList: JSON.stringify(this.srcFileKeyList),
              SrcFolderInfoList: JSON.stringify(this.srcFolderKeyList),
              DestFolderInfo: this.destFolderInfo.destfolderkey,
              IsTzuser: true,
              FmFolderOperation: true,
              FmFileOperation: true,
            }
            // api呼び出し
            API_STFMFM02C21(param).then((response)=>{
              if(response.result === "0000"){
                this.deleteCopyParam();
                //  モーダル画面を閉じる
                this.$emit("close-stfmf02c21",true);
              }
              else{
                // エラー表示
                var errParaList = [];
                if(response.errorParaList != null && response.errorParaList.length > 0){
                  errParaList = response.errorParaList;
                }
                this.errors.push(
                  Common.createError(
                    response.errorCD,
                    Common.getMessage(response.errorCD, errParaList)
                  )
                );  
              }
              this.processDialogue(false);
            });
          }
        },
        // **********************************************
        // * キャンセルボタンをクリック
        // **********************************************
        canselBtnClicked(){
          this.deleteCopyParam();
          this.clearError();
          //  モーダル画面を閉じる
          this.$emit("close-stfmf02c21",false);
        },
        // **********************************************
        // * 子画面(フォルダ一覧画面)を閉じる。
        // **********************************************
        closeSTFMF02C22(isSelected,dest){
          if(isSelected){
            // 確定ボタン押下
            this.destFolderInfo.destPath = dest.folderPath;
            this.destFolderInfo.name = dest.name;
            this.destFolderInfo.destfolderkey = dest.folderkey;
          }
          this.isFolderListShow = false;
          
          this.initfocus();
        },
        // **********************************************
        // * ファイル情報->ファイルキー情報
        // **********************************************
        convertFileInfoToFileKey(){
          if(this.srcFileList != null){
            for(let i = 0 ;i < this.srcFileList.length;i++){
            
              let item = JSON.parse(this.srcFileList[i]);
              let filekey = {
                FileId:item.FileId,
                Version:item.Version,
                FileName:item.FileName,
                FolderKey:item.FolderKey,
              }
            
              this.srcFileKeyList.push(filekey); 
            }
          }
        },
        // **********************************************
        // * フォルダ情報->フォルダキー情報
        // **********************************************
        convertFolderInfoToFolderKey(){
          if(this.srcFolderList  != null){
            for(let i = 0;i<this.srcFolderList.length;i++){
              let item = JSON.parse(this.srcFolderList[i]);
              let folderkey = {
                BusinessOperatorId:item.BusinessOperatorId,
                FolderType:item.FolderType,
                FolderId:item.FolderId,
                FolderName:item.FolderName,
                FolderPath:item.FolderPath,
              }
              this.srcFolderKeyList.push(folderkey);
            }
          }
        },
        // **********************************************
        // * 複写移動対象・複写移動先パラメータ削除
        // **********************************************
        deleteCopyParam(){
          this.srcFileKeyList = [];
          this.srcFolderKeyList = [];
          this.destFolderInfo.destPath="";
          this.destFolderInfo.destfolderkey = "";
          this.destFolderInfo.name = "";
        },
        // **********************************************
        // * エラーメッセージ初期化
        // **********************************************
        clearError(){
          this.errors = [];
        },
        // **********************************************
        // * フォーカス初期化
        // **********************************************
        initfocus(){
          this.$refs['selectdestbtn'].focus();
          
          // 子画面から遷移した時に子画面(フォルダ一覧画面)の初期フォーカスに、
          // フォーカスが飛んでしまうことがあるためリセットして再度フォーカスを設定する。
          let currentfocus = document.activeElement.id;
          if(currentfocus.startsWith("dataline")){
            document.activeElement.blur();
            this.$refs['selectdestbtn'].focus();
          }
          
        },
        onblur(e){
          if(!e) return;
          e.preventDefault();
          this.initfocus();
        }
      },
  }

</script>